import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";

import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";

import NotFound from "pages/NotFound";
import N8nMakeComWorkflows from "./pages/n8n-make-com-workflows";
import WhatsAppEmailAutomation from "./pages/whats-app-email-automation";
import Pricing from "./pages/pricing";
import Contact from "./pages/contact";
import AIChatbotAutomation from "./pages/ai-chatbot-automation";
import Blog from "./pages/blog";
import CustomAPIIntegrations from "./pages/custom-api-integrations";
import ServicesOverview from "./pages/services-overview";
import IndustrySolutions from "./pages/industry-solutions";
import AboutUs from "./pages/about-us";
import CaseStudiesPage from "./pages/case-studies";
import Homepage from "./pages/homepage";
import BlogPostPage from "./pages/blog/BlogPostPage";

// Digital marketing service pages
import SeoServices from "./pages/seo-services";
import LocalSeo from "./pages/local-seo";
import SocialMediaMarketing from "./pages/social-media-marketing";
import GoogleAdsPpc from "./pages/google-ads-ppc";
import MetaAds from "./pages/meta-ads";
import ContentMarketing from "./pages/content-marketing";
import EmailMarketing from "./pages/email-marketing";
import AnalyticsCro from "./pages/analytics-and-cro";

// Legal pages
import PrivacyPolicy from "./pages/privacy";
import TermsOfService from "./pages/terms";
import CookiePolicy from "./pages/cookies";

// ✅ Admin-related imports
import AdminLogin from "./pages/admin/AdminLogin";
import BlogAdmin from "pages/admin/BlogAdmin";
import AdminRoute from "./routes/AdminRoute";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminLeads from "./pages/admin/AdminLeads";




const Routes: React.FC = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/n8n-make-com-workflows" element={<N8nMakeComWorkflows />} />
          <Route path="/whats-app-email-automation" element={<WhatsAppEmailAutomation />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/ai-chatbot-automation" element={<AIChatbotAutomation />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/custom-api-integrations" element={<CustomAPIIntegrations />} />
          <Route path="/services-overview" element={<ServicesOverview />} />
          <Route path="/industry-solutions" element={<IndustrySolutions />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          {/* Digital marketing services */}
          <Route path="/seo-services" element={<SeoServices />} />
          <Route path="/local-seo" element={<LocalSeo />} />
          <Route path="/social-media-marketing" element={<SocialMediaMarketing />} />
          <Route path="/google-ads-ppc" element={<GoogleAdsPpc />} />
          <Route path="/meta-ads" element={<MetaAds />} />
          <Route path="/content-marketing" element={<ContentMarketing />} />
          <Route path="/email-marketing" element={<EmailMarketing />} />
          <Route path="/analytics-and-cro" element={<AnalyticsCro />} />
          {/* Legal pages */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={ <AdminRoute> <AdminDashboard /> </AdminRoute>} />
          <Route path="/admin/blog" element={ <AdminRoute> <BlogAdmin /> </AdminRoute> } />
          <Route path="/admin/leads" element={ <AdminRoute> <AdminLeads /> </AdminRoute>  } />
          <Route path="*" element={<NotFound />} />
         
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
